export default __webpack_public_path__ + "static/media/expert_3.7a791850.png";